var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dashboard-view',[_c('h2',[_vm._v(_vm._s(_vm.siteTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }